import {StyleSheet} from "aphrodite";

import {mediaQueries} from "@khan/shared-styles";

export default StyleSheet.create({
    hideWhenSmall: {
        [mediaQueries.smOrSmaller]: {
            display: "none",
        },
    },
    hideWhenMedium: {
        [mediaQueries.mdOrSmaller]: {
            display: "none",
        },
    },
});
